import { mapState } from 'vuex';

export default {
    name: 'atext',
    props: {
        source : Array,
        data : Object
    },

    data : function(){

        return {
            loading : false
        }

    },

    created : () => {

    },

    watch: {
        //$route: 'getdata'
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
        groupText : function(){

            var g = this.$f.group(this.source, function(f){
                return f.section || "___UNNAMED___"
            })

            return g

        }
    }),

    methods : {
        exsource : function(t){

            var text = t.text;

            var dis = 0;
            var d = this.data

            var title = function(id){

                if(!id) return ''

                var obj = d.cuis[id] || d.bib_entries[id] || d.ref_entries[id]

                if(!obj) return ''

                return obj.Name || obj.title || obj.text || ""
            }

            _.each(t.cite_spans, function(s){
                s.t = 'cite'
            })

            _.each(t.ref_spans, function(s){
                s.t = 'ref'
            })

            var refs = [].concat(t.cite_spans, t.ref_spans, t.cuis)

            refs = _.filter(refs, function(r){
                return r
            })

            refs = _.sortBy(refs, function(r){
                return r.start
            })

            
            _.each(refs, function(s){

                var l = ''
                var l2 = ''

                if(s.t == 'ref' && s.ref_id){
                    l = '<span class="ref" to="'+(s.ref_id || "")+'" title="'+title(s.ref_id)+'">'
                    l2 = '</span>'
                }

                if(s.t == 'cite' && s.ref_id){
                    l = '<span class="ref" to="'+(s.ref_id || "")+'" title="'+title(s.ref_id)+'">'
                    l2 = '</span>'
                }

                if(s.t == 'cui'){
                    l = '<mark class="refcui" to="'+s.cui+'" cid="'+s.id+'" title="'+title(s.cui)+'">'
                    l2 = '</mark>'
                }

                if(!l && !l2) return

                var d = l.length
                var d2 = l2.length


                text = text.substr(0, s.start + dis) + l + text.substr(s.start + dis)

                dis += d;

                text = text.substr(0, s.end + dis) + l2 + text.substr(s.end + dis)

                dis += d2;

            })

          
            

            return text
        }
    },
}